import { motion } from "framer-motion";
import { Coffee, Cpu, Zap } from "lucide-react";

const stats = [
  { icon: Cpu, label: "High-end PCs", value: "Gaming rigs" },
  { icon: Coffee, label: "Specialty Coffee", value: "All Day" },
  { icon: Zap, label: "High-quality Internet", value: "Low ping" },
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 bg-[#0A0A0A] overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Left: Text */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-7"
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-sky-400" />
              <span className="font-mono text-[11px] tracking-[0.3em] text-sky-400 uppercase">
                Welcome to the Spot
              </span>
            </div>

            <h2 className="font-display text-white text-4xl md:text-5xl lg:text-6xl uppercase leading-[0.95]">
              Ενα μερος <br />
              για <span className="text-sky-400">ολους.</span> <br />
              <span className="text-zinc-500">Gamers και μη.</span>
            </h2>

            <p className="mt-8 text-zinc-400 text-base md:text-lg leading-relaxed max-w-2xl">
              Στο TED Coffee & Fun Spot θα βρεις ό,τι χρειάζεται ένας gamer, casual ή hardcore.
              High-end σταθμοί, ταχύτατη σύνδεση, ζεστή ατμόσφαιρα και ένας πραγματικά καλός καφές
              που κρατάει τα reflexes σου στο 100%. Είτε ήρθες για ένα quick match, είτε για ολονυχτία,
              ο χώρος σε περιμένει.
            </p>

            <div className="mt-10 grid sm:grid-cols-3 gap-4">
              {stats.map((s) => (
                <div
                  key={s.label}
                  className="border border-zinc-800 bg-zinc-900/40 p-5 hover:border-sky-400/50 transition-colors"
                >
                  <s.icon className="w-5 h-5 text-sky-400 mb-3" />
                  <div className="text-white font-bold text-sm uppercase tracking-wider">
                    {s.label}
                  </div>
                  <div className="text-zinc-500 text-xs mt-1 font-mono">{s.value}</div>
                </div>
              ))}
            </div>
          </motion.div>

          {/* Right: Image */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-5 relative"
          >
            <div className="relative aspect-[4/5] overflow-hidden border border-zinc-800 shot-wrap">
              <img
                src="/shop/gmaps-4.jpg"
                alt="Παιδί που παίζει στο Ted Coffee & Fun Spot"
                className="w-full h-full object-cover shot-enhance"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between">
                <div>
                  <div className="font-mono text-[10px] tracking-[0.3em] text-sky-400 uppercase mb-1">
                    Location
                  </div>
                  <div className="font-display text-white text-xl uppercase">
                    Χαλκιδα · Ιατριδου 8
                  </div>
                </div>
                <div className="text-right">
                  <div className="font-mono text-[10px] tracking-[0.3em] text-zinc-400 uppercase">
                    Est.
                  </div>
                  <div className="font-display text-sky-400 text-2xl">2014</div>
                </div>
              </div>
            </div>
            {/* Yellow accent frame */}
            <div className="absolute -bottom-4 -right-4 w-32 h-32 border-2 border-sky-400 -z-0 hidden md:block" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
